const ArticleState = {
    DRAFT: "Draft",
    SUBMITTED: "Submitted",
    APPROVED: "Approved",
    LIVE: "Live",
}
export default ArticleState;
